import { Guid } from "guid-typescript";
import { IField } from "../../IField";

//Generated code, do not modify

export class EventTypeItemResponse {
    id!: Guid;
    name!: string;
    slug!: string;

    public static Fields = {
        id: { name: "id", type: "Guid" },
        name: { name: "name", type: "string" },
        slug: { name: "slug", type: "string" },
    } as Record<"id" | "name" | "slug", IField>;
}
